module.exports = __webpack_public_path__ + "static/media/1628613217646-removebg-preview.ca448449.png";